import { useEffect, useState } from 'react';
import { Spinner as ThemeUISpinner } from 'theme-ui';
import Flex from './Flex';

export function Spinner ({ delay = 300, sx = {}, ...props }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, delay);
  }, []);

  return show
    ? <ThemeUISpinner
        m={2}
        sx={{
          ...sx
        }}
        {...props}
      />
    : null;
}

export function Loader({ sx = {}, ...props }) {
  return (
    <Flex
      sx={{
        height: '100vh',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx
      }}
      {...props}
    >
      <Spinner/>
    </Flex>
  );
}
